import { Controller } from 'stimulus'
import Swiper, { Navigation, EffectFade } from 'swiper' // Import EffectFade
import AnimationHelper from 'shared/assets/javascript/animation_helper';

Swiper.use([Navigation, EffectFade]) // Use EffectFade

export default class extends Controller {

  static targets = ['traySlider', 'contentSlider'];

  connect() {
    const animationHelper = new AnimationHelper();
    this.windowWidth = window.innerWidth;
    
    this.initMenu()
    window.addEventListener('load', this.updateMenuContentHeight.bind(this))
    window.addEventListener('resize', animationHelper.debounce(this.onResize.bind(this), 200));
  }

  onResize() {
    if (this.windowWidth === window.innerWidth) return; // Prevent unnecessary reinitialization if width hasn't changed
    this.windowWidth = window.innerWidth;
    
    if (!!this.menuTray) this.menuTray.destroy();
    if (!!this.menuContent) this.menuContent.destroy();
    
    this.initMenu();
    this.updateMenuContentHeight();
  }

  initMenu() {
    const menuTraySelector = '.js-menuTray'
    const menuTrayElement = this.element.querySelector(menuTraySelector)
    const menuSlides = parseInt(menuTrayElement.dataset.slides) || 'auto'

    let tabletSlidesPerView = 'auto';
    let tabletSpaceBetween = 0;
    let tabletSlidesOffsetAfter = 0;
    let tabletAllowTouchMove = false;

    let desktopSlidesPerView = 'auto';
    let desktopSpaceBetween = 0;
    let desktopSlidesOffsetAfter = 0;
    let desktopAllowTouchMove = false;

    if (menuSlides > 5) {
      tabletSlidesPerView = 5.8;
      tabletSlidesOffsetAfter = 60;
      tabletAllowTouchMove = true;
      tabletSpaceBetween = 60;
    }
    if (menuSlides > 8) {
      desktopSlidesPerView = 8.8;
      desktopSpaceBetween = 90;
      desktopSlidesOffsetAfter = 75;
      desktopAllowTouchMove = true;
    }

    if (menuTrayElement) {
      this.menuTray = new Swiper(this.traySliderTarget, {
        slidesPerView: 3,
        slidesPerGroup: 1,
        slidesOffsetAfter: 0,
        centeredSlides: true,
        initialSlide: 1,
        threshold: 35,
        resistance: true,
        resistanceRatio: 0.85,
        autoHeight: true,
        breakpoints: {
          700: {
            slidesPerView: tabletSlidesPerView,
            freeMode: true,
            spaceBetween: tabletSpaceBetween,
            centeredSlides: false,
            centeredSlidesBounds: false,
            allowTouchMove: tabletAllowTouchMove,
            threshold: 70,
            initialSlide: 0,
            slidesOffsetAfter: tabletSlidesOffsetAfter,
          },
          1280: {
            slidesPerView: desktopSlidesPerView,
            freeMode: true,
            spaceBetween: desktopSpaceBetween,
            centeredSlides: false,
            centeredSlidesBounds: false,
            allowTouchMove: desktopAllowTouchMove,
            initialSlide: 0,
            slidesOffsetAfter: desktopSlidesOffsetAfter,
          }
        }
      })
      this.menuTray.updateSlidesClasses()
    }

    // Create menuContent Swiper instance
    const menuContentSelector = '.js-menuContent'
    const menuContentElement = this.element.querySelector(menuContentSelector)

    if (menuContentElement) {
      this.menuContent = new Swiper(this.contentSliderTarget, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoHeight: true,
        navigation: false,
        freeMode: false,
        centeredSlides: false,
        threshold: 35,
        resistance: true,
        resistanceRatio: 0.85,
        spaceBetween: 0,
        speed: 600,
        allowTouchMove: false,
        breakpoints: {
          700: {
            threshold: 70,
            centeredSlides: true,
          },
        }
      })
    }

    // Make sure both instances exist before linking
    if (this.menuTray && this.menuContent) {
      // When the active slide of menuTray changes, update the active slide of menuContent
      this.menuTray.on('slideChange', () => {
        this.menuContent.slideTo(this.menuTray.activeIndex);
        this.menuTray.updateSlidesClasses();
      })
    }
  }

  slideTo(e) {
    let index = e.currentTarget.dataset.index
    this.menuContent.slideTo(index);
    this.menuTray.activeIndex = index;
    if (window?.innerWidth < 700) {
      this.menuTray.slideTo(index);
    }
    this.menuTray.updateSlidesClasses()
  }

  /**
   * Workaround for autoHeight not working on some edge cases
   * - initial slide has significantly less content than at least one other slide
   * - the height of the largest slide is at least 150% of the viewport height
   * - the page loads with the menu in view, and the above conditions are met
   */
  updateMenuContentHeight() {
    this.menuContent?.updateAutoHeight()
  }
}
